export const CK_HASH = "";
export const BACK_URL = '';
export const RESERVE_COOKIES = '';
